module.exports = __webpack_public_path__ + "media/images/icons/icons_small/15_2hearts-e5b8179658660ee712e594176ae393b9.png";